import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {UnitShort} from '@common-module/modelinterfaces/unit-short.model';
import {SelectedService} from '../../../shared/services/selected.service';
import {UserUnitGroups} from '@common-module/modelinterfaces/user-unit-groups.model';
import {UnitGroup} from '@common-module/modelinterfaces/unit-group.model';
import {NgStyle} from '@angular/common';
import {UnitListComponent} from '../unit-list/unit-list.component';
import {TranslateModule} from '@ngx-translate/core';
import {MaterialModule} from "@common-module/material.module";

interface GroupView {
  group: UnitGroup;
  units: UnitShort[];
  selectedCountLabel: string;
}

@Component({
    selector: 'app-user-expandable',
    templateUrl: './user-expandable.component.html',
    styleUrls: ['./user-expandable.component.scss'],
    imports: [MaterialModule, UnitListComponent, NgStyle, TranslateModule]
})

export class UserExpandableComponent implements OnChanges {

  @Input() filter: string;
  @Input() searchStr: string;
  @Input() selectedUnitIdListByUser: number[] = [];
  @Input() allUnitsFiltered: UnitShort[] = [];
  @Input() user: UserUnitGroups;

  public unitCount: number;
  public unitsByUserFiltered: UnitShort[] = [];
  public groupViews: GroupView[] = [];

  private filteredIdSet = new Set<number>();

  constructor(private selectedService: SelectedService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['allUnitsFiltered'] || changes['user']) && this.allUnitsFiltered && this.user) {
      this.filteredIdSet = new Set(this.allUnitsFiltered.map(unit => unit.id));
      const allUserUnits = this.user.shared.concat(this.user.owned);
      this.unitsByUserFiltered = allUserUnits.filter(unit => this.filteredIdSet.has(unit.id));
      this.unitCount = this.unitsByUserFiltered.length;
      this.rebuildGroupViews();
    } else if (changes['selectedUnitIdListByUser']) {
      // selection changed — refresh the "selected / total" labels
      this.rebuildGroupViews();
    }
  }

  public expand(): void {
    this.selectedService.appendSelectedUser(this.user.id);
  }

  public collapse(): void {
    this.selectedService.removeSelectedUser(this.user.id);
  }

  private rebuildGroupViews(): void {
    const selected = this.selectedService.getInstantUnitIdsSet();
    this.groupViews = (this.user?.groups || []).map(group => {
      const selectedCount = group.units.reduce((acc, unit) => acc + (selected.has(unit.id) ? 1 : 0), 0);
      return {
        group: group,
        units: group.units.filter(unit => this.filteredIdSet.has(unit.id)),
        selectedCountLabel: selectedCount > 0 ? selectedCount + ' / ' : ''
      };
    });
  }
}
